import React from 'react'
import AppLayout from '../../../layout/components/AppLayout'
import { Link } from 'react-router-dom'
import { BusinessCenter, Dashboard, DoorSliding, Dvr, FollowTheSigns, ListAlt, Newspaper, PeopleOutline, QuestionAnswer, TransferWithinAStation, Tv } from '@mui/icons-material'

function AdminLandingPage() {
  return (
    <AppLayout>
      <div className='container'>
        <div className='row mt-5 text-center'>
          <div className='col-md-6 my-3'>
              <div className='card bg-primary p-3 ' >
                <Link to={"/user/list"} className='btn text-white'   >
                  <h3><PeopleOutline style={{fontSize:60}} /></h3>
                  <p>Manage Users</p>
                </Link>
              </div>
          </div>
          <div className='col-md-6 my-3'>
              <div className='card bg-primary p-3 ' >
                <Link to={"/business/details"} className='btn text-white'   >
                  <h3><BusinessCenter style={{fontSize:60}} /></h3>
                  <p>Business Details</p>
                </Link>
              </div>
          </div>
          
          <div className='col-md-6 my-3'>
              <div className='card bg-primary p-3 ' >
                <Link to={"/admin/response-message/grid"} className='btn text-white'   >
                  <h3><Dashboard style={{fontSize:60}} /></h3>
                  <p>Response Messages</p>
                </Link>
              </div>
          </div>
          <div className='col-md-6 my-3'>
              <div className='card bg-primary p-3 ' >
                <Link to={"/grievance/list"} className='btn text-white'   >
                  <h3><Dashboard style={{fontSize:60}} /></h3>
                  <p>Grievance List</p>
                </Link>
              </div>
          </div>

          
        </div>
      </div>
    </AppLayout>  
  )
}

export default AdminLandingPage